<script lang="ts">
    import Artwork from '~/components/jet/Artwork/Artwork.svelte';
    import MiniPlayerShared from '@amp/web-app-components/src/components/MiniPlayer/MiniPlayer.svelte';
    import NowPlayingMetadata from '~/components/structure/Players/components/NowPlayingMetadata.svelte';
    import { getPlayback } from '~/utils/playback';
    import { queueMetadata } from '~/stores/queue-metadata';
    import type { QueueItemMetadata } from '~/jet/models';

    const { queue } = getPlayback();

    export let item: QueueItemMetadata | null = null;
    export let playerClick: (e: Event) => void;

    $: artwork = item?.artwork;
</script>

<div class="mini-player-container" data-testid="mini-player-container">
    <MiniPlayerShared {playerClick} showProgressBar={false}>
        <div
            class="mini-player__artwork"
            slot="mini-player-artwork"
            data-testid="mini-player-artwork"
        >
            <Artwork
                {artwork}
                profile={'miniplayer'}
                forceCropCode={true}
                disableAutoCenter={true}
            />
        </div>
        <div class="mini-player__metadata--text" slot="mini-player-text">
            {#if item?.title}
                <div
                    class="mini-player__text--primary"
                    data-testid="mini-player-title"
                >
                    <div class="mini-player__clamp-wrapper" dir="auto">
                        <NowPlayingMetadata
                            {item}
                            hasMultiLineTitle={false}
                            showAccessoryButtons={false}
                            isMiniPlayerMeta={true}
                        />
                    </div>
                </div>
            {/if}
        </div>
    </MiniPlayerShared>
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/sasskit-stylekit/ac-sasskit-config';
    @use 'ac-sasskit/core/locale' as *;
    @use '@amp/web-shared-styles/app/core/mixins/after-shadow' as *;

    .mini-player-container {
        $mini-player-gutter: 12px;
        $mini-player-icon-size: 32px;
        --miniPlayerMarginStart: 0px;
        position: fixed;
        bottom: 5px;
        display: flex;
        justify-content: center;
        width: 100vw;
        z-index: var(--z-index-mini-player);

        :global(.mini-player) {
            width: calc(100vw - ($mini-player-gutter * 2));
        }

        :global(.mini-player__body) {
            gap: 0;
        }

        :global(.mini-player__metadata) {
            height: 40px;
        }

        :global(amp-icon),
        :global(amp-playback-controls-item-skip) {
            --playback-control-icon-width: #{$mini-player-icon-size};
            --playback-control-icon-height: #{$mini-player-icon-size};
            --skip-icon-width: #{$mini-player-icon-size};
            --skip-icon-height: #{$mini-player-icon-size};
        }
    }

    .mini-player__artwork {
        width: 40px;
        height: 40px;
        border-radius: 6px;
        flex-shrink: 0;
        overflow: hidden;
        margin-inline-end: 8px;

        &--video {
            width: 72px;
        }
    }

    .mini-player__text--primary {
        display: inline-grid;
        align-items: baseline;
        grid-template-columns: 1fr auto;
        text-align: start;
    }
</style>
